import { Button, Grid } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import './guarantorCard.css';
import CustomisedButton from '../../button/button';
import { IGuarantorEditCard } from './IGuarantorCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { IInquiryResponse, IInquiryResult, TotalInquiryRequest } from '../../../models/inquiry.model';
import { GUARANTOR_MOBILE, GUARANTOR_REQUIRED_OTP, INQUIRY_REQUIRED_OTP } from '../../../config/cacheKey';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { deleteGuarantor } from '../../../services/guarantor.service';
import { IDeleteGuarantorRequest } from '../../../models/guarantor.model';
import { setGuarantorInfo } from '../../../redux/guarantor/guarantorInfoSlice';
import ConfirmDeleteModal from '../../modal/confirmDeleteModal';

export default function GuarantorDeleteCard({
    firstName,
    lastName,
    nationalCode,
    backgroundColor,
    title,
    referenceKey,
    setChildValue,
    guarantorKey,
    setIsDelete,
    mobileNumber
}: IGuarantorEditCard) {
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    useEffect(() => {
        if (confirm === true) {
            removeDocument();
        }
    }, [confirm])
    function removeDocument() {
        const deleteGuarantor = {} as IDeleteGuarantorRequest;
        deleteGuarantor.key = guarantorKey!;
        deleteGuarantor.referenceKey = referenceKey!;
        DeleteGuarantorMutate(deleteGuarantor);
    }
    function deleteImage() {
        setOpenVerifyModal(true);
    }

    function callTotalInquiry() {
        setChildValue(guarantorKey);
        dispatch(setGuarantorInfo({ title, guarantorKey }));
    }
    useEffect(() => {
        queryClient.setQueryData(GUARANTOR_MOBILE, mobileNumber)
    }, [])
    const [inquiryRequiredOtp, setInquiryRequiredOtp] = useState(queryClient.getQueryData(GUARANTOR_REQUIRED_OTP) as IInquiryResult);
    const guarantorKey_Redux = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );
    function handleBtnClick(values: string) {
        // const queryClient = useQueryClient();
        const request = {} as TotalInquiryRequest;
        request.otp = values;
        request.referenceKey = referenceKey!;
        request.otpInquiryType = inquiryRequiredOtp?.inquiryType;
        request.otpReference = inquiryRequiredOtp?.inquiryOtpReference;

        if (guarantorKey_Redux) {
            request.guarantorKey = guarantorKey_Redux;
        }
    }
    const { mutate: DeleteGuarantorMutate } = useMutation(
        deleteGuarantor,
        {
            onSuccess: (data: boolean) => {
                if (data) {
                    setIsDelete(true);
                }
            },
        }
    );
    return (
        <>
            <Grid
                className={'borderColorPrimaryColorLight-300'}
                style={{
                    border: '1.5px solid ',
                    height: 'fit-content',
                    borderRadius: '5px',
                    background: '#fff',
                    alignContent: 'center',
                    marginTop: '10px',
                    backgroundColor: backgroundColor,
                    minHeight: '110px',
                }}
                container
                spacing={0}
                xs={12}
            // onClick={() => onClick!()}
            >
                <Grid container item spacing={0} xs={12} style={{ margin: '20px', marginBottom: '10px' }}>
                    <div style={{ display: 'inline-block', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }} onClick={() => callTotalInquiry()}>
                                <span style={{ fontSize: "14px", fontWeight: "bold" }} className={"text-sm " + "primaryColorLight-900"}>{title}</span>
                                <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "12.5px" }}>
                                    {firstName + " " + lastName + " - " + "کدملی" + nationalCode}
                                </span>
                                <hr
                                    className="hrRequest"
                                    style={{
                                        marginTop: '20px',
                                        marginBottom: '5px',
                                    }}
                                />
                            </div>
                            <Grid container xs={12} style={{ textAlign: 'justify' }}>
                                {/* <div onClick={() => clickDel()}> */}
                                <div onClick={() => deleteImage()}>
                                    <DeleteOutlineOutlinedIcon />
                                    <span style={{ fontSize: "12.5px", fontWeight: 'bold' }}>حذف ضامن</span>
                                </div>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <ConfirmDeleteModal text={"آیا از حذف این مدرک اطمینان داید؟"}
                buttonTitle={'حذف'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
            />
        </>
    );
}

